import { c as _c } from "react/compiler-runtime"; /* eslint-disable-next-line no-restricted-imports */
import { useQuery as useApolloQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { Kind } from 'graphql';
import { print } from 'graphql/language/printer';
import { useState } from 'react';
const useQuery = (query, options) => {
    const $ = _c(7);
    const [, setFakeState] = useState();
    let t0;
    if ($[0] !== options || $[1] !== query || $[2] !== setFakeState) {
        t0 = (error) => {
            const pathname = typeof window !== "undefined" ? `${window.location.pathname}` : "ssr";
            Sentry.setTag("pathname", pathname);
            const operationDefinition = query.definitions.find(_temp);
            const name = operationDefinition.name?.value;
            Sentry.setTag("query.name", name);
            Sentry.setExtra("query.variables", options?.variables);
            Sentry.setExtra("query.operation", print(query));
            Sentry.setExtra("query.options", options);
            if (options?.onError) {
                options.onError(error);
            }
            error.name = name ? `${error.name} ${name}` : error.name;
            setFakeState(() => {
                throw (error);
            });
        };
        $[0] = options;
        $[1] = query;
        $[2] = setFakeState;
        $[3] = t0;
    }
    else {
        t0 = $[3];
    }
    const onError = t0;
    let t1;
    if ($[4] !== onError || $[5] !== options) {
        t1 = { ...options, onError };
        $[4] = onError;
        $[5] = options;
        $[6] = t1;
    }
    else {
        t1 = $[6];
    }
    return useApolloQuery(query, t1);
};
export default useQuery;
function _temp(t0) { const { kind } = t0; return kind === Kind.OPERATION_DEFINITION; }
